import { PersonCard } from "../PersonCard";

export function GridPerson(props){
    let render
    if(props.object.length === 0){
        render = <></>
    } else if(props.object.length === 1) {
        return <div class="col-md-4">
            <PersonCard object={props.object[0]} index={props.object.id} cityList={props.cityList} key={props.object.id} returnTo={"/person_list"}/>
        </div>
    } else if(props.object.length === 2) {
        return <>
        <div class="col-md-4">
            <PersonCard object={props.object[0]} index={props.object.id} cityList={props.cityList} key={props.object.id} returnTo={"/person_list"}/>
        </div>
        <div class="col-md-4">
            <PersonCard object={props.object[1]} index={props.object.id} cityList={props.cityList} key={props.object.id} returnTo={"/person_list"}/>
        </div>
        </>
    } else if(props.object.length === 3) {
        return <><div class="col-md-4">
            <PersonCard object={props.object[0]} index={props.object.id} cityList={props.cityList} key={props.object.id} returnTo={"/person_list"}/>
        </div>
        <div class="col-md-4">
            <PersonCard object={props.object[1]} index={props.object.id} cityList={props.cityList} key={props.object.id} returnTo={"/person_list"}/>
        </div>
        <div class="col-md-4">
            <PersonCard object={props.object[2]} index={props.object.id} cityList={props.cityList} key={props.object.id} returnTo={"/person_list"}/>
        </div>
        </>
    }
}